/**
 * Calendar Sheet Service
 *
 * Loads and saves calendar events via the Cloudflare Pages proxy endpoint
 * (/api/calendar-events), which forwards requests to the Google Apps Script
 * Web App from the server side to avoid CORS issues.
 */

/**
 * Delete a finalized event record from the FinalizedEvents sheet
 * @param {string} eventId
 */
export async function deleteFinalizedEvent(eventId) {
  try {
    await fetch('/api/calendar-events', {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventId }),
    });
  } catch {
    // best-effort
  }
}

/**
 * Load events from the proxy API
 * @returns {Promise<{events: Array, source: string}>}
 */
export async function loadCalendarEvents() {
  try {
    const res = await fetch('/api/calendar-events');
    if (res.ok) {
      const data = await res.json();
      if (Array.isArray(data.events)) {
        return { events: data.events, source: 'proxy' };
      }
    }
  } catch {
    // proxy unavailable
  }

  return { events: [], source: 'none' };
}

/**
 * Save events via the proxy API
 * @param {Array} events
 */
export async function saveCalendarEvents(events) {
  try {
    await fetch('/api/calendar-events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ events }),
    });
  } catch {
    // proxy unavailable - events may be lost unless cached elsewhere
  }
}

const CalendarSheetService = {
  loadCalendarEvents,
  saveCalendarEvents,
  deleteFinalizedEvent,
};

export default CalendarSheetService;